import { Placeholder } from 'semantic-ui-react'

import { FlexRow } from '@/ui'
import { MobilePlaceholder } from './Styles'

const EmployeeSidebarPlaceholder = () => (
  <FlexRow justifyContent="flex-start" style={{ marginBottom: '2em' }}>
    <MobilePlaceholder style={{ height: 69, width: 69 }}>
      <Placeholder.Image />
    </MobilePlaceholder>

    <MobilePlaceholder style={{ width: 200, marginTop: 0, marginLeft: 12 }}>
      <Placeholder.Header>
        <Placeholder.Line />
        <Placeholder.Line />
      </Placeholder.Header>
    </MobilePlaceholder>
  </FlexRow>
)

export default EmployeeSidebarPlaceholder
